import { takeLatestApiCall } from 'syft-acp-core/sagas/helpers'

import { EMPLOYER_VENUE_NAME_FETCH_BEGIN, EMPLOYER_VENUE_SEARCH_FETCH_BEGIN } from './action-types'
import { fetchEmployerVenueName, searchEmployerVenues } from './api'

export function* saga() {
  yield takeLatestApiCall(EMPLOYER_VENUE_SEARCH_FETCH_BEGIN, searchEmployerVenues)
  yield takeLatestApiCall(EMPLOYER_VENUE_NAME_FETCH_BEGIN, fetchEmployerVenueName)
}
